import * as Dialog from "@radix-ui/react-dialog";
import MuxPlayer from "@mux/mux-player-react";
import "@mux/mux-player/themes/microvideo";

interface VideoModalProps {
	open: boolean;
	onOpenChange: (open: boolean) => void;
	playbackId: string;
}

export default function VideoModal({ open, onOpenChange, playbackId }: VideoModalProps) {
	return (
		<Dialog.Root open={open} onOpenChange={onOpenChange}>
			<Dialog.Portal>
				<Dialog.Overlay className="fixed inset-0 bg-black/90 z-50" />
				<Dialog.Content className="fixed inset-0 z-50 flex items-center justify-center p-4 md:p-8">
					<div className="relative w-full max-w-4xl">
						{/* Close button */}
						<Dialog.Close asChild>
							<button
								className="absolute -top-12 right-0 flex items-center gap-2 text-white/70 hover:text-white transition-colors text-sm"
								aria-label="Close"
							>
								<span>Close</span>
								<svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
									<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
								</svg>
							</button>
						</Dialog.Close>

						{/* Video container with aspect ratio */}
						<div className="relative rounded-xl overflow-hidden bg-black shadow-2xl">
							<div className="aspect-video">
								<MuxPlayer
									playbackId={playbackId}
									theme="microvideo"
									autoPlay
									accentColor="#6366f1"
									style={{
										width: "100%",
										height: "100%",
										aspectRatio: "16/9",
									}}
								/>
							</div>
						</div>
					</div>
				</Dialog.Content>
			</Dialog.Portal>
		</Dialog.Root>
	);
}
